import { defineMessages } from 'react-intl';

export default defineMessages({
    notAvailable: {
        id: 'select.notAvailable',
        defaultMessage: 'n/a',
    },
})
